import React, { useState } from 'react';

const Pagination = ({ totalPages = 10, currentPage = 1, onPageChange }) => {
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange && onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const visibleCount = 3;

    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(startPage + visibleCount - 1, totalPages - 1);

    if (endPage - startPage < visibleCount - 1) {
      startPage = Math.max(1, endPage - visibleCount + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => goToPage(i)}
          className={`w-10 h-10 rounded-lg text-sm font-medium border ${
            currentPage === i
              ? 'bg-[#674936] text-white'
              : 'bg-white text-black hover:bg-gray-100'
          }`}
        >
          {i}
        </button>
      );
    }

    // Add ellipsis if there's a gap before the last page
    if (endPage < totalPages - 1) {
      pages.push(
        <span key="dots" className="w-10 h-10 flex items-center justify-center text-gray-500">
          ...
        </span>
      );
    }

    // Always show the last page
    if (totalPages > 1) {
      pages.push(
        <button
          key={totalPages}
          onClick={() => goToPage(totalPages)}
          className={`w-10 h-10 rounded-lg text-sm font-medium border ${
            currentPage === totalPages
              ? 'bg-[#674936] text-white'
              : 'bg-white text-black hover:bg-gray-100'
          }`}
        >
          {totalPages}
        </button>
      );
    }

    return pages;
  };

  return (
    <div className="flex flex-wrap justify-center gap-2 p-3 items-center max-w-full">
      {/* Left arrow */}
      <button
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
        className={`w-10 h-10 rounded-lg border text-lg ${
          currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'hover:bg-gray-100'
        }`}
      >
        &lt;
      </button>

      {renderPageNumbers()}

      {/* Right arrow */}
      <button
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`w-10 h-10 rounded-lg border text-lg ${
          currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'hover:bg-gray-100'
        }`}
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination;
